import { designTokens } from '@monorepo/nova-ui';
import { Box, Stack, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledCarouselContainer = styled(Box)(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === 'dark'
      ? 'rgba(0, 0, 0, 0.6)'
      : 'rgba(255, 255, 255, 0.6)',
  backdropFilter: 'blur(10px)',
  borderBottom: `1px solid ${theme.palette.secondary.dark}`,
  boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.15)',
  width: '100%',
  height: '84px',
  overflow: 'hidden',
  padding: theme.spacing(3),
  position: 'relative',
}));

export const StyledScrollTrack = styled(Stack)({
  flexDirection: 'row',
  gap: '24px',
  alignItems: 'center',
  width: 'fit-content',
  willChange: 'transform',
});

export const StyledWinnerCard = styled(Stack)({
  flexDirection: 'row',
  gap: '8px',
  alignItems: 'center',
  flexShrink: 0,
  height: '56.78px',
  cursor: 'pointer',
});

export const StyledAvatarContainer = styled(Box)({
  position: 'relative',
  width: '69px',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-end',
  justifyContent: 'space-between',
});

export const StyledAvatar = styled(Box)(({ theme }) => ({
  width: '52.694px',
  height: '52.694px',
  borderRadius: '50%',
  backgroundColor:
    theme.palette.mode === 'dark'
      ? designTokens.colors.neutral[1200]
      : theme.palette.background.paper,
  border:
    theme.palette.mode === 'dark'
      ? `6px solid ${designTokens.colors.blue[1100]}`
      : `6px solid ${designTokens.colors.blue[1000]}`,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  overflow: 'hidden',
  flexShrink: 0,
}));

export const StyledAvatarImage = styled('img')({
  width: '100%',
  height: '100%',
  objectFit: 'cover',
});

export const StyledInitials = styled(Typography)(({ theme }) => ({
  fontSize: '20px',
  fontWeight: 400,
  lineHeight: 1.4,
  letterSpacing: '0.03px',
  color: theme.palette.text.primary,
  textAlign: 'center',
  fontFamily: '"General Sans", sans-serif',
  userSelect: 'none',
  width: '32px',
  height: '28px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

export const StyledCountryFlag = styled(Box)({
  position: 'absolute',
  bottom: '0px',
  right: '0px',
  width: '18.58px',
  height: '18.58px',
  borderRadius: '50%',
  overflow: 'hidden',
  pointerEvents: 'none',
  zIndex: 1,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '& > *': {
    width: '90%',
    height: '90%',
  },
});

export const StyledInfoContainer = styled(Stack)({
  flexDirection: 'column',
  gap: '2px',
  width: '110px',
  alignItems: 'flex-start',
});

export const StyledUsername = styled(Typography)(({ theme }) => ({
  fontSize: '12px',
  fontWeight: 400,
  lineHeight: 1.4,
  letterSpacing: '0.06px',
  color: theme.palette.text.primary,
  fontFamily: '"General Sans", sans-serif',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  width: '100%',
}));

export const StyledEarnings = styled(Typography)(({ theme }) => ({
  fontSize: '18px',
  fontWeight: 500,
  lineHeight: 1.4,
  letterSpacing: '0.027px',
  color: theme.palette.text.primary,
  fontFamily: '"General Sans", sans-serif',
}));
